import { LocalService } from './../../../../services/storage/localService';
import { EmpresasService } from './../../../../services/empresas/empresas.service';
import { FacturacionCPEService } from 'app/services/facturacion-cpe/facturacion-cpe.service';
import { Component, OnInit, Output, Input, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesStatus, MessagesDates } from '../../../../models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { DeudasService } from 'app/services/cobranzas/deudas/deudas.service';
import * as moment from 'moment';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-facturacion-deuda',
  templateUrl: './facturacion-deuda.component.html',
  styleUrls: ['./facturacion-deuda.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class FacturacionDeudaComponent implements OnInit {
  readonly IGV_Porcentaje = this.localService.getJsonValue('ParametroIGVPorcentaje');
  idProv  = new FormControl();
  loading :boolean = false;
  save : boolean = false;  
  user:any;
  proveedoresArr : any;
  productosarr : any;
  flagCreateUpdate :boolean = false;
  titulo:string = "Facturar deuda";
  subtitulo: string = "";
  ruc = new FormControl();
  filteredProveeedor: Observable<any[]>;
  @Input() deuda: any;
  @Output() cerrarFacturacionDeuda = new EventEmitter<boolean>();
  now = moment();

  id;
  idCli = "";
  RUC_CLI: string;
  cliId = new FormControl();
  filteredCliente: Observable<any[]>;
  clientesArr;

  CPETemporal: any = {}
  ArrayDetalle: any = {}

  form: FormGroup;
  dataSource: any;
  monedaElement: string;
  tipoPagoCPEElement = 114;

  str: any;
  rCliCombo: any;
  search: boolean = true;
  dataCorreos: any = [];
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  correoCrt = new FormControl('', [Validators.required]);
  filteredCorreos: Observable<string[]>;
  correos: string[] = [];
  allprueba: string[] = [];

  dataComprobante: any = [];

  @ViewChild('correoInput', { static: true }) correoInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto2', { static: true }) matAutocomplete: MatAutocomplete;
  constructor(private datepipe :DatePipe,
              private cpeService:FacturacionCPEService,
              private DeudasService1:DeudasService,
              private msgStatus:MessagesStatus,
              private msgTitulos : MessagesTitles,
              private EmpresasService1:EmpresasService,
              private localService : LocalService){

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.form = new FormGroup({
      idDeuda: new FormControl({ value: "", disabled: true }),
      idProveedor: new FormControl({ value: "", disabled: true }),
      Razon_Social: new FormControl({ value: "", disabled: true }),
      Serie: new FormControl('F002'),
      Codigo_Producto: new FormControl({ value: "", disabled: true }),
      Descripcion: new FormControl({ value: "", disabled: true }),
      Moneda: new FormControl({ value: "", disabled: true }),
      Deuda_Importe: new FormControl({ value: "", disabled: true }),
      FechaEmision: new FormControl(this.now),
      TipoPago: new FormControl(this.tipoPagoCPEElement),
      Alta_Usuario: new FormControl(this.user.Usuario),
    })

  }

  ngOnInit() {

    if (this.deuda.Estado == 'C') {
      this.tipoPagoCPEElement = 114;
      this.form.controls['TipoPago'].setValue(this.tipoPagoCPEElement);
    } else {
      this.tipoPagoCPEElement = 115;
      this.form.controls['TipoPago'].setValue(this.tipoPagoCPEElement);
    }

    this.datosDeuda(this.deuda);
    this.ListarRepresentantesCli();
  }
  tipoPagoCPE(event) {
    this.form.controls['TipoPago'].setValue(event);
  }

  tipoMoneda(event) {
    this.form.controls['Moneda'].setValue(event);
  }

  CerrarPopUp() {
    this.cerrarFacturacionDeuda.emit();
  }

  obtenerProductos() {
    this.DeudasService1.obtenerProductos().subscribe(res => {
      this.productosarr = res;
    })
  }

  datosDeuda(element) {
    this.flagCreateUpdate = true;
    this.productosarr = element.productos;
    this.titulo = "Facturar deuda";
    this.subtitulo = "Nro " + element.idDeuda;
    this.ruc.setValue(element.Razon_Social);
    this.form.controls['idDeuda'].setValue(element.idDeuda);
    this.form.controls['idProveedor'].setValue(element.idProveedor);
    this.form.controls['Razon_Social'].setValue(element.Razon_Social);
    this.form.controls['Moneda'].setValue(element.Moneda);
    this.form.controls['Deuda_Importe'].setValue(element.Deuda_Importe);
    this.form.controls['Codigo_Producto'].setValue(element.Codigo_Producto);
    this.form.controls['Descripcion'].setValue(element.Descripcion);
    this.form.controls['Alta_Usuario'].setValue(element.Alta_Usuario);
    this.monedaElement = element.Moneda;
  }
  setPrecio(evento) {
    this.productosarr.forEach(element => {
      if (element.idProducto == evento.value) {
        this.form.controls['Deuda_Importe'].setValue(element.Precio);
      }
    });
  }

  guardarComprobante(){
   this.str = this.correos.join(";")
   let IGV = this.IGV_Porcentaje;

    if (this.correos.length == 0) {
      Swal.fire({
        title: "Warning",
        text: "Seleccione ó escriba un correo",
        type: 'warning',
        allowOutsideClick: true,
        heightAuto: false
      })
      return false;
    }

    this.CPETemporal.Detalle = [];
    this.CPETemporal.idLocal = 1;
    this.CPETemporal.idDeuda = this.deuda.idDeuda;
    this.CPETemporal.idCliente = this.deuda.idEmpresa
    this.CPETemporal.Serie = this.form.controls['Serie'].value;
    this.CPETemporal.Tipo_Pago = this.form.controls['TipoPago'].value;
    this.CPETemporal.Fecha_Emision = this.datepipe.transform(this.form.controls['FechaEmision'].value, 'yyyy-MM-dd');
    this.CPETemporal.Moneda = this.deuda.Moneda
    this.CPETemporal.Valor_Venta = Number(this.deuda.Deuda_Importe);
    this.CPETemporal.IGV_Importe = Math.round((this.deuda.Deuda_Importe * IGV) * 100) / 100;
    this.CPETemporal.Precio_Venta = Math.round((Number(this.CPETemporal.Valor_Venta) + this.CPETemporal.IGV_Importe) * 100) / 100;
    this.CPETemporal.Correo = this.str;

    this.ArrayDetalle.Codigo_Producto = this.deuda.Codigo_Producto;
    this.ArrayDetalle.Descripcion = this.deuda.Descripcion;
    this.ArrayDetalle.Unidad_Medida = 'NIU';
    this.ArrayDetalle.Cantidad = 1;
    this.ArrayDetalle.Valor_Unitario = Number(this.deuda.Deuda_Importe);
    this.ArrayDetalle.Valor_Venta = Number(this.deuda.Deuda_Importe);
    this.ArrayDetalle.IGV_Importe = Math.round((this.deuda.Deuda_Importe * IGV) * 100) / 100;
    this.ArrayDetalle.Precio_Venta = Math.round((Number(this.ArrayDetalle.Valor_Venta) + this.ArrayDetalle.IGV_Importe) * 100) / 100;

    this.CPETemporal.Detalle.push(this.ArrayDetalle)

    Swal.fire({
      title: "Espere...",
      text: "Guardando la información.",
      type: "info",
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.cpeService.GuardarCPEFacturaDeuda(this.CPETemporal)
      .subscribe(res => {
        this.loading = false;
        this.save = true;
        Swal.fire({
          title: '¡Registro exitoso!',
          text: '¿Desea enviar comprobante a Efact.?',
          type: "success",
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí',
          cancelButtonText: 'No',
          heightAuto: false
        }).then((result) => {
          if (result.value) {
            this.dataComprobante = res;
            Swal.fire({
              title: "Espere...",
              text: "Enviando a Efact",
              type: "info",
              allowOutsideClick: false,
              heightAuto: false
            });
            Swal.showLoading();
            this.cpeService.eFactEnviar(this.dataComprobante["message"].Cabecera.idComprobanteIF).subscribe(
              res1 => {
                this.loading = false;
                Swal.fire({
                  type: 'success',
                  title: 'Éxito',
                  text: '¡Enviado satisfactoriamente a eFact!',
                  allowOutsideClick: false,
                  heightAuto: false
                });
                this.cerrarFacturacionDeuda.emit();
              }, err => {
                this.loading = false;
                Swal.fire({
                  title: "¡Algo salió mal!",
                  text: err.error['error'],
                  type: "warning",
                  allowOutsideClick: true,
                  heightAuto: false
                });
              }
            )
          } else if (
            result.dismiss === Swal.DismissReason.cancel
          ) {
            this.cerrarFacturacionDeuda.emit();
          }
        });

      },
        (err: HttpErrorResponse) => {
          this.loading = false;
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "Comprobante de pago. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
        }
      );

  }


  // eFactSend(element:any){

 

  ListarRepresentantesCli() {
    this.idCli = this.deuda.idEmpresa;
    if (this.idCli == '' || this.idCli == '0') {
      return
    }
    if (this.search) {

      this.EmpresasService1.obtenerContactosEmpresa(this.idCli).subscribe(
        res => {      
          this.rCliCombo = res;
          this.rCliCombo = this.rCliCombo.filter(
            state => state.Des_Estado.toLowerCase().indexOf('activo') === 0
          );
          this.dataCorreos = this.rCliCombo
          for (let item of this.dataCorreos) {
            this.allprueba.splice(1, 0, item.Correo);
          }
          this.filteredCorreos = this.correoCrt.valueChanges.pipe(
            startWith(null),
            map((fruit: string | null) => fruit ? this._filter(fruit) : this.allprueba.slice()));
        }, (err: HttpErrorResponse) => {
          this.msgStatus.getMessage(err.status);
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "REPRESENTANTES no encontrado. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        });
    } else {
      return;
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim() && this.correos.length < 3) {
      this.correos.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
    this.correoCrt.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.correos.indexOf(fruit);
    if (index >= 0) {
      this.correos.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (this.correos.length < 3) {
      this.correos.push(event.option.viewValue);
      this.correoInput.nativeElement.value = '';
      this.correoCrt.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allprueba.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  // LimpiarRepresentantes(){
  //   this.search = true;
  //   this.allprueba.splice(0,this.allprueba.length);
  //   this.correos.splice(0,this.correos.length);
  //   this.correoCrt.setValue('');
  // }
}
